var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    viewBox: "0 0 24 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5 0H0v19h24V0h-.5zM22 1L12 8.8 2 1h20zM1 18V1.6l10.7 8.3h.6L23 1.6V18H1z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyNCIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDI0IDE5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAxOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTIzLjUsMGgtMjNIMHYxOWgyNFYwSDIzLjV6IE0yMiwxTDEyLDguOEwyLDFIMjJ6IE0xLDE4VjEuNmwxMC43LDguM2gwLjZMMjMsMS42VjE4SDF6Ii8+Cjwvc3ZnPgo=";
export { SvgEnvelopeIcon as ReactComponent };